import React from "react";
import { GalleryModel } from "../../models/GalleryModel";
import { MediaModalItemModel } from "../../models/MediaModalModel";
import { MediaType } from "../../models/MediaType";
import FullGalleryItem from "./FullGalleryItem";
import { ModelBasePath } from "../../utils/ModelBasePath";
import CustomEvent from "custom-event";
import chunk from "lodash/chunk";

interface FullGalleryState {
  page: number;
}

interface FullGalleryProps {
  content: GalleryModel[];
  fullGalleryMode: boolean;
}

class FullGallery extends React.Component<FullGalleryProps, FullGalleryState> {
  itemsPerRow: number = 3;
  rowsPerPage: number = 1;

  constructor(props: FullGalleryProps) {
    super(props);
    this.state = {
      page: 0
    };

    this.loadMore = this.loadMore.bind(this);
    this.selectItem = this.selectItem.bind(this);
  }

  get visibleItems(): GalleryModel[] {
    return this.props.content.slice(0, this.itemsPerRow * (this.state.page + 1) * this.rowsPerPage);
  }

  get contentRows(): any[] {
    return chunk(this.visibleItems, this.itemsPerRow);
  }

  loadMore(e?): void {
    if (e) e.preventDefault();
    this.setState({ page: this.state.page + 1 });
  }

  selectItem(item: GalleryModel): void {
    const selectedItem = {
      media: item.media,
      title: item.title,
      text: item.text,
      type: item.type || MediaType.Image
    };
   
    const evt = new CustomEvent("showMediaModal", { detail: { content: [selectedItem] } });
    window.dispatchEvent(evt);
  }

  render() {
    const { content, fullGalleryMode } = this.props;

    return (
      <section className="fullGallery">
        {this.contentRows.map((items: GalleryModel[], index: number) => {
          return (
            <div
              key={index}
              className={`fullGallery__row ${
                index % 2 ? "fullGallery__row--even" : "fullGallery__row--odd"
              }`}
            >
              {items.map((item: GalleryModel, index: number) => {
                return <FullGalleryItem key={index} content={item} onSelect={this.selectItem} />;
              })}
            </div>
          );
        })}

        {content.length > this.visibleItems.length && fullGalleryMode ? (
          <p className="text-center">
            <a href="#" className="btn btn--secondary fullGallery__btn" onClick={this.loadMore}>
              Load more
            </a>
          </p>
        ) : null}

        {!fullGalleryMode && content.length > 1 ? (
          <p className="text-center">
            <a href={`${ModelBasePath}gallery/all`} className="btn btn--secondary fullGallery__btn">
              Go to full gallery
            </a>
          </p>
        ) : null}
      </section>
    );
  }
}

export default FullGallery;
